import React from "react";

const PixlLabsFooter = () => {
  return (
    <div className="footer">
      <a
        href="https://www.omnia.lol"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="./images/omnia_logo.png"
          alt="Omnia logo"
          style={{
            width: "100px",
            height: "32px",
            position: "relative",
            marginRight: "0px",
            borderRadius: "4px",
          }}
        />
      </a>
      <a
        href="https://www.omnia.lol/hatching"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="./images/omnis.png"
          alt="Omnia hatch"
          style={{
            width: "37px",
            height: "35px",
            position: "relative",
          }}
        />
        Hatch
      </a>
      <a
        href="https://x.com/ExploreOmnia"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="./images/x.png"
          alt="X logo"
          style={{
            width: "20px",
            height: "20px",
            position: "relative",
          }}
        />
        
      </a>
      <a
        href="https://opensea.io/collection/omnia-pets-genesis"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="./images/os.svg"
          alt="os logo"
          style={{
            width: "25px",
            height: "25px",
            position: "relative",
          }}
        />
        
      </a>
      <a
        href="https://dexscreener.com/ethereum/0x31c0ba10e4e12be6cdceb612e5e829d977532bfc"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="./images/dexscreener.png"
          alt="dexscreener logo"
          style={{
            width: "20px",
            height: "20px",
            position: "relative",
          }}
        />
      </a>
      <a
        href="https://x.com/hornelius"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="./images/hornelius.jpg"
          alt="hornelius"
          style={{
            width: "25px",
            height: "25px",
            position: "relative",
            borderRadius: "100%",
          }}
        />
      </a>
    </div>
    
  );
};

export default PixlLabsFooter; 
